import HTTPClient from "./http-client";

class HistoricalService {
  async getDailyCountiesInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailylocationsinterruptions`,
      payload,
      headers
    );
  }
  async getHourlyCountiesInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlylocationsinterruptions`,
      payload,
      headers
    );
  }

  async getDailyRegionalsInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyregionalsinterruptions`,
      payload,
      headers
    );
  }
  async getHourlyRegionalsInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyregionalsinterruptions`,
      payload,
      headers
    );
  }

  async getDailyAgenciesInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyagenciesinterruptions`,
      payload,
      headers
    );
  }

  async getHourlyAgenciesInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyagenciesinterruptions`,
      payload,
      headers
    );
  }

  async getRegionalDailySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/regionaldailysummary`, payload, headers);
  }

  async getAgencyDailySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/agencydailysummary`, payload, headers);
  }

  async getCityDailySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/citydailysummary`, payload, headers);
  }

  async getRegionalHourlySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/regionalhourlysummary`, payload, headers);
  }

  async getAgencyHourlySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/agencyhourlysummary`, payload, headers);
  }

  async getCityHourlySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/cityhourlysummary`, payload, headers);
  }

  async getDailyLightningCountCity(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/dailylightningcountcity`, payload, headers);
  }

  async getDailyLightningCountAgency(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/dailylightningcountagency`, payload, headers);
  }

  async getDailyLightningCountRegional(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/dailylightningcountregional`, payload, headers);
  }

  async getHourlyLightningCountCity(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/hourlylightningcountcity`, payload, headers);
  }

  async getHourlyLightningCountAgency(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/hourlylightningcountagency`, payload, headers);
  }

  async getHourlyLightningCountRegional(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(
      `/alertadis/hourlylightningcountregional`,
      payload,
      headers
    );
  }

  async getAgencycopel(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/agencycopel`, payload, headers);
  }

  async getCityCopel(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    const headers = { headers: { "Content-Type": "application/json" } };

    return api.post(`/alertadis/citycopel`, payload, headers);
  }

  async getDailyFullRegionalsInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyregionalsinterruptionsonly`,
      payload,
      headers
    );
  }

  async getHourlyFullRegionalsInterruptions(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyregionalsinterruptionsonly`,
      payload,
      headers
    );
  }

  async getRegionalCopel(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/regionalcopel`, payload, headers);
  }

  async getDailyForecastsRegionals(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyforecastsregionals`,
      payload,
      headers
    );
  }

  async getDailyForecastsAgencies(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyforecastsagencies`,
      payload,
      headers
    );
  }

  async getDailyForecastsCouties(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/dailyforecastslocations`,
      payload,
      headers
    );
  }

  async getHourlyForecastsRegionals(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyforecastsregionals`,
      payload,
      headers
    );
  }

  async getHourlyForecastsAgencies(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyforecastsagencies`,
      payload,
      headers
    );
  }

  async getHourlyForecastsCouties(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(
      `/alertadis/historical/hourlyforecastslocations`,
      payload,
      headers
    );
  }

  async getRegionalCitiesDailySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/regionalcitiesdailysummary`, payload, headers);
  }

  async getAgencyCitiesDailySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/agencycitiesdailysummary`, payload, headers);
  }

  async getRegionalCitiesHourlySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/regionalcitieshourlysummary`, payload, headers);
  }

  
  async getAgencyCitiesHourlySummary(payload) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configureRestTelemetric();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/alertadis/agencycitieshourlysummary`, payload, headers);
  }
}

export default new HistoricalService();
